import type { ReactNode } from "react";

import { Label } from "@/components/ui/label";

interface FieldProps {
  label: string;
  children: ReactNode;
}

export const Field = ({ label, children }: FieldProps) => (
  <div className="space-y-2">
    <Label className="text-[11px] font-medium uppercase tracking-[0.08em] text-muted-foreground">
      {label}
    </Label>
    {children}
  </div>
);
